import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
export const Spinner = (props)=>{
    const { className, variant = 'border', bsStyle, bsSize } = props;
    const bsStyleClass = bsStyle ? `text-${bsStyle}` : null;
    const bsSizeClass = bsSize ? `spinner-${variant}-${bsSize}` : null;
    const bsClass = classnames(className, bsStyleClass, `spinner-${variant}`, bsSizeClass);
    return /*#__PURE__*/ _jsx("div", {
        className: bsClass,
        role: "status",
        children: /*#__PURE__*/ _jsx("span", {
            className: "visually-hidden",
            children: "Loading..."
        })
    });
};
